import PrintDataService from '@bto-services/api/shared/print-data-service';
import BetslipPrintService from '@bto-services/print/betslip-print-service';
import Vue from 'vue';

export default class AutoPrintService {
  /**
   * To-Do if betslipPlacement signalR can send us the placed ticket (same model as history details) use that object to render Print
   * @param {Object} response
   * @param {Object} betslipgroup
   */
  static startAutoPrint(response, betslipgroupId = 0) {
    let bps = new BetslipPrintService(typeof APP_SETTINGS.print !== 'undefined' ? APP_SETTINGS.print.printTicketWidth : '');
    const bsgId = betslipgroupId || response.BetSlipGroupID;
    let printDataService = new PrintDataService();
    printDataService.getData(bsgId).then((betslipObj) => {
      this.startExternalPrint(betslipObj);
      bps.printBetslip(null, bsgId, betslipObj, false, '');
    });
  }
  // old Print method needs to be removed on version 3.1
  static startAutoPrintDelayed(response) {
    if (response.FreeBetAward || response.ResponseCode !== 0 || response.BetSlipStatusTypeID !== 0) {
      return;
    }
    let bps = new BetslipPrintService(typeof APP_SETTINGS.print !== 'undefined' ? APP_SETTINGS.print.printTicketWidth : '');
    let printDataService = new PrintDataService();
    /**
     * start the print with delay, after the message is shown.
     * Needed because API may not yet have data
     */
    setTimeout(() => {
      printDataService.getData(response.BetSlipGroupID).then((betslipObj) => {
        this.startExternalPrint(betslipObj);
        bps.printBetslip(null, response.BetSlipGroupID, betslipObj, false, '');
      });
    }, 1000);
  }
  /**
   * Open websocket connection and send message (for goverment fiscal printers)
   * used only from camanbet now. If needed for other clients we need to make message configurable
   * @param {Object} betslipObj history details model
   */
  static startExternalPrint(betslipObj) {
    const wsUrl = APP_SETTINGS.print.webSocketUrl;
    if (!wsUrl) {
      return;
    }
    try {
      var ws = new WebSocket(wsUrl);
      ws.onopen = function () {
        ws.send(
          `<ticket epos-tn='${betslipObj.betSlipGroupID}' riskamt='${betslipObj.stake}' winamt='${betslipObj.potWinnings}' desc='${Vue.prototype.$translate.text(betslipObj.betSlipGroupType)
          }' teams='' />`
        );
        ws.close();
      };
    }
    catch (err) {
      // eslint-disable-next-line
      console.log("WS error:", err);
    }
  }
}